// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0bdb775d","239":"6cbd43f3","455":"e3d50047","977":"e0972723"}[chunkId] + ".chunk.js";
};